module.exports = __webpack_public_path__ + "img/framboise_shell_cooked.407497e0.jpg";